module.exports = __webpack_public_path__ + "static/media/frozen.6e7fef3c.mp3";